import type { AnalyticsBrowser, EventProperties } from '@segment/analytics-next'

let enabled = false
let client: Promise<{ analytics: AnalyticsBrowser }> | null = null
let lastPage: string | null = null

function getClient() {
  const writeKey = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY
  if (!writeKey) return null
  client ??= import('@segment/analytics-next').then(({ AnalyticsBrowser }) => ({
    analytics: AnalyticsBrowser.load({ writeKey }),
  }))
  return client
}

export function setAnalyticsEnabled(value: boolean) {
  enabled = value
  if (!value) lastPage = null
}

export async function trackPage(path: string, isCurrent: () => boolean) {
  if (!enabled) return
  const loaded = await getClient()
  if (!loaded || !enabled || !isCurrent() || lastPage === path) return
  lastPage = path
  void loaded.analytics.page()
}

export function trackEvent(eventName: string, properties?: EventProperties) {
  if (!enabled) return
  void getClient()?.then(({ analytics }) => {
    if (enabled) void analytics.track(eventName, properties)
  })
}
